import { MapPin } from "lucide-react";
import { AREAS } from "@/data/site";
import { SECTION, BTN_PLATINUM } from "./styles";

export const ServiceAreas = () => {
  return (
    <section id="areas" data-testid="areas-section" className={`${SECTION} bg-[#0A1F3C]`}>
      <div className="grid lg:grid-cols-2 gap-14 items-center">
        <div>
          <p className="font-accent-script text-2xl md:text-3xl text-[#D4AF37] mb-3">Where We Work</p>
          <h2
            className="font-serif text-3xl md:text-5xl font-semibold text-white gold-underline"
            data-testid="areas-headline"
          >
            PROUDLY SERVING CENTRAL VIRGINIA
          </h2>
          <p className="text-gray-300 mt-6 mb-10 leading-relaxed">
            Local homeowners trust Apex Home Renovation LLC across the greater Central Virginia
            region. If you don't see your town listed, reach out — we may still be able to help.
          </p>
          <ul className="grid grid-cols-1 sm:grid-cols-2 gap-x-8 gap-y-4 mb-10" data-testid="areas-list">
            {AREAS.map((a) => (
              <li
                key={a}
                data-testid={`area-item-${a.toLowerCase().replace(/[^a-z]+/g, "-")}`}
                className="flex items-center gap-3 text-gray-200 border-b border-white/10 pb-3"
              >
                <MapPin className="h-4 w-4 text-[#D4AF37] shrink-0" />
                <span className="text-sm tracking-wide">{a}</span>
              </li>
            ))}
          </ul>
          <a href="#estimate" data-testid="areas-request-estimate-btn" className={BTN_PLATINUM}>
            Request an Estimate
          </a>
        </div>

        <div className="border border-[#D4AF37]/40 p-1" data-testid="areas-map">
          <iframe
            title="Apex Home Renovation service area — Central Virginia"
            src="https://www.google.com/maps?q=Petersburg,+VA&z=8&output=embed"
            className="w-full h-[420px] grayscale-[35%] contrast-[1.05]"
            loading="lazy"
          />
        </div>
      </div>
    </section>
  );
};
